import axios from 'axios'
import {
  getToken,
  setToken,
  removeToken,
  getRefreshToken,
  setRefreshToken,
  removeRefreshToken
} from '@/utils/auth'
import { Message, Loading } from 'element-ui'
import { getUrlAddU } from '@/utils/index'
// /biz/dpskpmg
export const prefixUrlBiz = 'biz/dps-kpmg'
// /auth/dpsauth
export const prefixUrlAuth = 'auth/dps-auth'

axios.defaults.headers['Content-Type'] = 'application/json'
function getHeader(config) {
  const Authorization = getToken()
  return {
    Authorization
  }
}
let loading = null
// 生成一个 axios 实例
const instance = axios.create({
  timeout: 1000 * 60 * 3, // 请求 超时配置
  baseURL: process.env.VUE_APP_BASE_API
})
// 请求 拦截器
instance.interceptors.request.use(
  (config) => {
    const header = getHeader(config)
    config.headers = Object.assign(config.headers, header)
    if (process.env.NODE_ENV === 'uat') {
      config.url = config.url.replace(config.url.split('/')[2], config.url.split('/')[2] + 'u')
    }
    if (config.requestType === 'export') {
      config.responseType = 'blob'
      loading = Loading.service({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    }
    if (config.requestType === 'upload') {
      loading = Loading.service({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    }
    if (config.requestType === 'verifyImg') {
      config.responseType = 'arraybuffer'
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)
// 响应 拦截器
let requests = []
let isNotRefreshing = true
instance.interceptors.response.use(
  (response) => {
    if (loading) {
      loading.close()
    }
    if (response.status === 200) {
      if (response.config.requestType === 'export') {
        if (response.data !== '') {
          return response
        } else {
          Message.error('表格导出失败')
          return Promise.reject(response.data)
        }
      }
      if (response.config.requestType === 'verifyImg') {
        if (response.data !== '') {
          return response
        } else {
          Message.error('验证码获取失败')
          return Promise.reject(response.data)
        }
      }
      if (response.data.code === 2000) {
        return response.data
      } else {
        if (response.data.code === 9001) {
          Message.error('Token认证失败，请重新登录！')
          setTimeout(() => {
            removeToken()
            removeRefreshToken()
            window.location.reload()
          }, 2000)
          return Promise.reject(response.data.message)
        } else if (response.data.code === 9000) {
          const config = response.config
          if (isNotRefreshing) {
            isNotRefreshing = false
            return axios
              .get(getUrlAddU(process.env.VUE_APP_BASE_API + `/${prefixUrlAuth}/kpmg/refreshToken`), {
                headers: { Authorization: getRefreshToken() }
              })
              .then((res) => {
                isNotRefreshing = true
                if (res.data.code === 2000) {
                  console.log(1258)
                  setToken(res.data.data.token)
                  setRefreshToken(res.data.data.refreshToken)
                  requests.forEach((run) => run())
                  requests = []
                  return instance(config)
                } else {
                  if (res.data.code === 9001) {
                    Message.error(res.data.message)
                    setTimeout(() => {
                      removeToken()
                      removeRefreshToken()
                      window.location.reload()
                    }, 2000)
                    return Promise.reject(res.data.message)
                  } else {
                    Message.error(res.data.message)
                    return Promise.reject(res.data.message)
                  }
                }
              })
              .catch((err) => {
                isNotRefreshing = true
                Message.error(err.data.message)
                return Promise.reject(err.data.message)
              })
          } else {
            return new Promise((resolve) => {
              requests.push(() => {
                resolve(instance(config))
              })
            })
          }
        } else {
          Message.error(response.data.message)
          return Promise.reject(response.data)
        }
      }
    } else {
      console.error(response.data)
      Message.error(response.data.message)
      return Promise.reject(response.data)
    }
  },
  (error) => {
    if (loading) {
      loading.close()
    }
    if (error.response.status === 401) {
      setTimeout(() => {
        removeToken()
        removeRefreshToken()
        window.location.reload()
      }, 2000)
      Message.error('Token认证失败，请重新登录！')
      return Promise.reject(error)
    }
    console.log('进入报错', error.toString())
    Message.error(error.toString())
    return Promise.reject(error)
  }
)

export default instance
